import { ApiCommonParams, ApiParams } from "../@types/apiTypes";

export function commonApiParamsToApiParams(params: ApiCommonParams): ApiParams {
  let apiParams: ApiParams = {};
  const { filters, orderBy, viewName, pagination, search } = params;
  if (!!filters) apiParams = { ...filters };
  if (!!orderBy) apiParams["order_by"] = orderBy;
  if (!!viewName) apiParams["view_name"] = viewName;
  if (!!search) apiParams["q"] = search;
  if (!!pagination) {
    const { pageNumber, pageSize } = pagination;
    if (!!pageNumber) apiParams["page_number"] = pageNumber;
    if (!!pageSize) apiParams["page_size"] = pageSize;
  }
  return apiParams;
}
